import { render, staticRenderFns } from "./CesionDetail.vue?vue&type=template&id=8289ea6a&scoped=true"
import script from "./CesionDetail.vue?vue&type=script&lang=js"
export * from "./CesionDetail.vue?vue&type=script&lang=js"
import style0 from "./CesionDetail.vue?vue&type=style&index=0&id=8289ea6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8289ea6a",
  null
  
)

export default component.exports